import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/engagement/feedback";

export const Route = createFileRoute("/admin/_engagement/feedback")({
  component: Page,
});
